export const ProjectName = process.env.REACT_APP_FB_PROJECT_ID || "styreportalen-development";
export const PortalUrl = process.env.REACT_APP_PORTAL_URL || "https://drift.styreportalen.no";
